'use client';

import React, { ReactElement, useEffect } from 'react';
import sanitize from '@/Util/sanitize';
import Keys from '@/Translations/generated/da/product.json.keys';
import { useTransitionState } from 'react-transition-state';
import { useTranslation } from '@/app/i18n/client';

const IntroductionText = ({ tripDescription }: { tripDescription?: string }): ReactElement => {
  const { t } = useTranslation('product');
  const paragraphs = tripDescription?.split('\n\n');
  const firstParagraph = paragraphs ? paragraphs[0] : '';
  const remainingDescription = paragraphs ? paragraphs.slice(1).join('\n\n') : '';

  const [{ status, isMounted }, toggle] = useTransitionState({
    timeout: 500,
    mountOnEnter: true,
    unmountOnExit: true,
    preEnter: true
  });

  useEffect(() => {
    toggle(false);
  }, []);

  return (
    <>
      <div
        className="introduction__description--desktop"
        dangerouslySetInnerHTML={{ __html: sanitize(tripDescription || '', true) }}
      />
      <div className="introduction__description--mobile">
        <div dangerouslySetInnerHTML={{ __html: sanitize(firstParagraph || '', true) }} />
        {isMounted && (
          <div
            className={`introduction__description--mobile__remaining${
              status === 'preEnter' || status === 'exiting'
                ? ' introduction__description--mobile__remaining--hidden'
                : ''
            }`}
            dangerouslySetInnerHTML={{
              __html: sanitize(remainingDescription || '', true)
            }}
          />
        )}
        {!!remainingDescription && (
          <div className="introduction__read-more" onClick={(): void => toggle(!isMounted)}>
            {isMounted ? t(Keys.showLess) : t(Keys.readMore)}
          </div>
        )}
      </div>
    </>
  );
};

export default IntroductionText;
